import { defineComponent as _defineComponent } from 'vue'
import { ref, watch, PropType, onMounted, computed } from "vue"
import Icon from "@/components/widgets/icons/Icon.vue"
import { UploadFileInput, UserInput, Mbti } from "@/gql"
import Dropzone from "@/components/widgets/input/Dropzone.vue"
import PhoneNumberInput from "@/components/widgets/input/PhoneInput.vue"
import { Theme } from "@/types"
import { THEMES } from "@/constants"
import { Genders } from "@/modules/Users/Invitation/constants"
import PasswordInput from "@/components/widgets/input/PasswordInput.vue"
import OutlinedSelect from "@/components/fields/OutlinedSelect.vue"

export type PersonalInfoForm = UserInput & {
  gender?: string | null
  dateOfBirth?: string | null
  currentOccupation?: string | null
  position?: string | null
  residentialAddress?: string | null
  bio?: string | null
  mbti?: string | null
  linkedinUrl?: string | null
  clientAdminPosition?: string | null
  phone?: {
    countryCode: string
    number: string
  }
  password?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PersonalInfoForm',
  props: {
  submitBtnLabel: {
    type: String,
    default: "Continue",
  },
  isSubmitting: {
    type: Boolean,
    required: false,
  },
  personalInformation: {
    type: Object as PropType<typeof form.value> | null,
    required: false,
  },
  theme: {
    type: Object as PropType<Theme>,
    default: () => ({
      primaryColor: THEMES.PERALTA_PRIMARY,
    }),
    required: false,
  },
  showAvatar: {
    type: Boolean,
    default: true,
  },
  form: {
    type: Object as PropType<PersonalInfoForm>,
    required: false,
  },
  isExistingEmail: {
    type: Boolean,
    default: false,
  },
  showPasswordInput: {
    type: Boolean,
    default: false,
  },
  fields: {
    type: Array as PropType<string[]>,
  },
},
  emits: ["submit", "change", "gotoPrev"],
  setup(__props, { emit }) {

const props = __props



const form = ref<PersonalInfoForm>({
  firstName: "",
  lastName: "",
  email: "",
  avatar: null,
  mbti: null,
  linkedinUrl: null,
  bio: null,
  residentialAddress: null,
  currentOccupation: null,
  dateOfBirth: null,
  gender: null,
})

const showUploadAvatarModal = ref(false)
const avatarPreviewUrl = ref<string | null>(null)
const uploadComplete = ref(false)

const mbtiList = computed(() => Object.values(Mbti))

watch(
  () => props.personalInformation,
  (personalInformation) => {
    if (!personalInformation) return

    form.value = {
      ...form.value,
      ...personalInformation,
    }
  },
  {
    immediate: true,
    deep: true,
  }
)



const observer = ref(null)

const onSubmit = async () => {
  const validity = await (observer.value as any)?.validateWithInfo()
  if (!validity.isValid) return
  emit("change", form.value)
  emit("submit")
}

const onAvatarChange = (file: File[]) => {
  if (file.length) {
    const url = URL.createObjectURL(file[0])
    avatarPreviewUrl.value = url
  }
}

const onFileUploadChange = (uploadedFile: UploadFileInput) => {
  if (uploadedFile?.key) uploadComplete.value = true
}

const onClose = () => {
  showUploadAvatarModal.value = false
  uploadComplete.value = false
}

onMounted(() => {
  form.value = {
    ...form.value,
    ...props.form,
  }
})

return { __sfc: true,props, form, showUploadAvatarModal, avatarPreviewUrl, uploadComplete, mbtiList, emit, observer, onSubmit, onAvatarChange, onFileUploadChange, onClose, Icon, Dropzone, PhoneNumberInput, Genders, PasswordInput, OutlinedSelect }
}

})